import { render, staticRenderFns } from "./addPlatPay.vue?vue&type=template&id=6dda2692&scoped=true&"
import script from "./addPlatPay.vue?vue&type=script&lang=js&"
export * from "./addPlatPay.vue?vue&type=script&lang=js&"
import style0 from "./addPlatPay.vue?vue&type=style&index=0&id=6dda2692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda2692",
  null
  
)

export default component.exports